import type { AuthUser, LoginResponse } from '../api/types'

export type AuthStatus = 'loading' | 'authenticated' | 'anonymous'
export interface AuthState {
  status: AuthStatus
  accessToken: string | null
  expiresAt: number // epoch ms; 0 when anonymous
  user: AuthUser | null
  lastError: 'network' | null // set when bootstrap could not reach the API
}

const INITIAL: AuthState = { status: 'loading', accessToken: null, expiresAt: 0, user: null, lastError: null }
let state: AuthState = INITIAL
const listeners = new Set<() => void>()
const emit = () => listeners.forEach((l) => l())

export const tokenStore = {
  getSnapshot: (): AuthState => state,
  subscribe(listener: () => void): () => void {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
  setSession(r: LoginResponse): void {
    state = { status: 'authenticated', accessToken: r.accessToken, expiresAt: Date.now() + r.expiresInSeconds * 1000, user: r.user, lastError: null }
    emit()
  },
  updateUser(user: AuthUser): void {
    state = { ...state, user }
    emit()
  },
  clear(reason: 'network' | null = null): void {
    state = { ...INITIAL, status: 'anonymous', lastError: reason }
    emit()
  },
  getAccessToken: (): string | null => state.accessToken,
  isExpiringSoon: (skewMs = 30_000): boolean => state.accessToken !== null && state.expiresAt - Date.now() < skewMs,
  _reset(): void {
    state = INITIAL
    listeners.clear()
  },
}
